import { Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function ConfirmButtonDialog({
    title,
    content,
    confirmFn,
    children,
    buttonProps = {},
    confirmButtonProps = {
        sx: { textTransform: "none", mx: '4px' },
        variant: 'contained',
        color: "error"
    },
    onClose = () => { },
    ...dialogProps
}) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false);
    const openDialogHandler = (event) => {
        event.stopPropagation()
        setOpen(true);
    };

    const closeDialogHandler = () => {
        setOpen(false);
        onClose()
    };

    const confirmationHandler = async () => {
        await confirmFn()
        closeDialogHandler()
    }

    return (
        <>
            <LoadingButton onClick={openDialogHandler} {...buttonProps}>
                {children}
            </LoadingButton>
            <Dialog
                open={open}
                onClose={(e) => e.preventDefault()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                {...dialogProps}
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{ textTransform: "none", }}
                        variant='contained'
                        onClick={closeDialogHandler}>{t("Close")}</Button>
                    <Button
                        onClick={confirmationHandler}
                        {...confirmButtonProps}
                    >
                        {t("Confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
